// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { EvidenceChaserDTO } from '../models';
/**
 * EvidenceChasersApi - axios parameter creator
 * @export
 */
export const EvidenceChasersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an evidence chaser
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceChaser(claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling createEvidenceChaser.');
            }
            const localVarPath = `/v2/claims/{claimId}/evidence-chaser`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Manually expire an evidence chaser
         * @param {string} claimId Claim id
         * @param {string} id Evidence chaser id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireEvidenceChaser(claimId: string, id: string, options: any = {}): RequestArgs {
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling expireEvidenceChaser.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling expireEvidenceChaser.');
            }
            const localVarPath = `/v2/claims/{claimId}/evidence-chaser/{id}/expire`
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an evidence chaser by id
         * @param {string} id Evidence chaser id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceChaserById(id: string, claimId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getEvidenceChaserById.');
            }
            // verify required parameter 'claimId' is not null or undefined
            if (claimId === null || claimId === undefined) {
                throw new RequiredError('claimId','Required parameter claimId was null or undefined when calling getEvidenceChaserById.');
            }
            const localVarPath = `/v2/claims/{claimId}/evidence-chaser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"claimId"}}`, encodeURIComponent(String(claimId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EvidenceChasersApi - functional programming interface
 * @export
 */
export const EvidenceChasersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create an evidence chaser
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceChaser(claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceChaserDTO> {
            const localVarAxiosArgs = EvidenceChasersApiAxiosParamCreator(configuration).createEvidenceChaser(claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Manually expire an evidence chaser
         * @param {string} claimId Claim id
         * @param {string} id Evidence chaser id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireEvidenceChaser(claimId: string, id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceChaserDTO> {
            const localVarAxiosArgs = EvidenceChasersApiAxiosParamCreator(configuration).expireEvidenceChaser(claimId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an evidence chaser by id
         * @param {string} id Evidence chaser id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceChaserById(id: string, claimId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<EvidenceChaserDTO> {
            const localVarAxiosArgs = EvidenceChasersApiAxiosParamCreator(configuration).getEvidenceChaserById(id, claimId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * EvidenceChasersApi - factory interface
 * @export
 */
export const EvidenceChasersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create an evidence chaser
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvidenceChaser(claimId: string, options?: any) {
            return EvidenceChasersApiFp(configuration).createEvidenceChaser(claimId, options)(axios, basePath);
        },
        /**
         * Manually expire an evidence chaser
         * @param {string} claimId Claim id
         * @param {string} id Evidence chaser id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        expireEvidenceChaser(claimId: string, id: string, options?: any) {
            return EvidenceChasersApiFp(configuration).expireEvidenceChaser(claimId, id, options)(axios, basePath);
        },
        /**
         * Get an evidence chaser by id
         * @param {string} id Evidence chaser id
         * @param {string} claimId Claim id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvidenceChaserById(id: string, claimId: string, options?: any) {
            return EvidenceChasersApiFp(configuration).getEvidenceChaserById(id, claimId, options)(axios, basePath);
        },
    };
};

/**
 * EvidenceChasersApi - interface
 * @export
 * @interface EvidenceChasersApi
 */
export interface EvidenceChasersApiInterface {
    /**
     * Create an evidence chaser
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvidenceChasersApiInterface
     */
    createEvidenceChaser(claimId: string, options?: any): AxiosPromise<EvidenceChaserDTO>;

    /**
     * Manually expire an evidence chaser
     * @param {string} claimId Claim id
     * @param {string} id Evidence chaser id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvidenceChasersApiInterface
     */
    expireEvidenceChaser(claimId: string, id: string, options?: any): AxiosPromise<EvidenceChaserDTO>;

    /**
     * Get an evidence chaser by id
     * @param {string} id Evidence chaser id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvidenceChasersApiInterface
     */
    getEvidenceChaserById(id: string, claimId: string, options?: any): AxiosPromise<EvidenceChaserDTO>;

}

/**
 * EvidenceChasersApi - object-oriented interface
 * @export
 * @class EvidenceChasersApi
 * @extends {BaseAPI}
 */
export class EvidenceChasersApi extends BaseAPI implements EvidenceChasersApiInterface {
    /**
     * Create an evidence chaser
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvidenceChasersApi
     */
    public createEvidenceChaser(claimId: string, options?: any) {
        return EvidenceChasersApiFp(this.configuration).createEvidenceChaser(claimId, options)(this.axios, this.basePath);
    }

    /**
     * Manually expire an evidence chaser
     * @param {string} claimId Claim id
     * @param {string} id Evidence chaser id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvidenceChasersApi
     */
    public expireEvidenceChaser(claimId: string, id: string, options?: any) {
        return EvidenceChasersApiFp(this.configuration).expireEvidenceChaser(claimId, id, options)(this.axios, this.basePath);
    }

    /**
     * Get an evidence chaser by id
     * @param {string} id Evidence chaser id
     * @param {string} claimId Claim id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EvidenceChasersApi
     */
    public getEvidenceChaserById(id: string, claimId: string, options?: any) {
        return EvidenceChasersApiFp(this.configuration).getEvidenceChaserById(id, claimId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for EvidenceChasersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create an evidence chaser
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createEvidenceChaser(
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<EvidenceChaserDTO> {
    const localVarAxiosArgs = EvidenceChasersApiAxiosParamCreator(configuration).createEvidenceChaser(claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Manually expire an evidence chaser
 * @param {string} claimId Claim id
 * @param {string} id Evidence chaser id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function expireEvidenceChaser(
    claimId: string,
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<EvidenceChaserDTO> {
    const localVarAxiosArgs = EvidenceChasersApiAxiosParamCreator(configuration).expireEvidenceChaser(claimId, id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an evidence chaser by id
 * @param {string} id Evidence chaser id
 * @param {string} claimId Claim id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getEvidenceChaserById(
    id: string,
    claimId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<EvidenceChaserDTO> {
    const localVarAxiosArgs = EvidenceChasersApiAxiosParamCreator(configuration).getEvidenceChaserById(id, claimId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

